import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CspInitializationService {

  constructor() {}

  /**
   * Initialize CSP based on environment configuration
   */
  initializeCSP(): void {
    if (environment.csp) {
      this.updateCSPMetaTag(environment.csp);
    }
  }

  /**
   * Update the CSP meta tag with the provided policy
   */
  private updateCSPMetaTag(cspPolicy: Record<string, string>): void {
    const cspString = Object.entries(cspPolicy)
      .map(([directive, value]) => `${directive} ${value}`)
      .join('; ');

    let metaTag = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
    
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('http-equiv', 'Content-Security-Policy');
      document.head.appendChild(metaTag);
    }
    
    metaTag.setAttribute('content', cspString);
  }

  /**
   * Get the current CSP policy from the meta tag
   */
  getCurrentCSPPolicy(): string | null {
    const metaTag = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
    return metaTag ? metaTag.getAttribute('content') : null;
  }
}
